import { LOGIC } from "Pages/GMS/ISR/ISRConstants";
import React, { useContext, useEffect } from "react";
import LogicRuleComponent from "Pages/GMS/ISR/Components/Rules/LogicRuleComponent";
import SidePanelComponent from "Pages/GMS/ISR/Components/RuleComponents/SidePanelComponent";
import { SB3RuleContext } from "Pages/GMS/ISR/Components/Rules/SB3RuleContext";
import { getISRProject } from "../DefineModel/ModelServices/ModalServices";
import { toast } from 'Components/DesignSystem/Toast/useToast';
import Spinner from "Components/DesignSystem/Spinner/Spinner";


type RulesComponentProps = {
    projectId: string | null | undefined
};


const RulesDialog = (props: React.PropsWithChildren<RulesComponentProps>
) => {
    const { updateModelData, showPickPanel, handleSaveRule, logicRule, showRulesMenu, toggleMenu, handleUpdateRule, resetLogicRule, loading } = useContext(SB3RuleContext)
    const overlayClasses =
        "tw-absolute tw-inset-0 tw-bg-black tw-opacity-50 tw-z-40 tw-h-full tw-w-full";
    const menuClasses = showRulesMenu
        ? `tw-absolute tw-top-0 tw-right-0 tw-h-full tw-max-h-full tw-overflow-auto  ${showPickPanel ? "tw-w-[84%]" : "tw-w-[64%]"} tw-bg-white tw-z-50  tw-shadow-lg`
        : "tw-hidden";

    useEffect(() => {
        const fetchISRProjects = async () => {
            try {
                if (props.projectId || logicRule?.project) {
                    const responseData = await getISRProject(props.projectId ?? logicRule?.project);
                    updateModelData(responseData?.data?.project)
                }
            } catch (error) {
                console.log(error)
            }
        }
        fetchISRProjects()
    }, [showPickPanel])

    const handleSaveMethod = () => {
        if (logicRule?.name) {
            handleSaveRule(props?.projectId)
        }
        else toast.info("Rule name is mandatory")
    }
    return (
        <div className="tw-h-[calc(100vh-60px)] tw-fixed tw-top-0 tw-left-0 tw-w-full tw-z-40 tw-mt-16 ">
            <div data-testid="rules-rulesdialog-div-1" className={overlayClasses} onClick={() => { resetLogicRule(); toggleMenu() }} />
            <div className={menuClasses}>
                <div
                    className={`tw-flex tw-justify-between tw-items-center tw-border-b tw-pb-2 tw-pt-4 tw-pr-2 tw-pl-2 tw-sticky tw-top-0 tw-bg-white tw-z-10`}
                >
                    <h2 className={`tw-text-[#091E42] tw-font-bold tw-text-sm`}>
                        {LOGIC} Rule
                    </h2>
                    <div className="tw-flex tw-items-center tw-gap-5">
                        <button data-testid="rules-rulesdialog-button-1"
                            onClick={() => { resetLogicRule(); toggleMenu() }}
                            className={`  tw-rounded  tw-bg-shades-of-grey-0 tw-text-primary tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary`}
                        >
                            Cancel
                        </button>
                        <button data-testid="rules-rulesdialog-button-2"
                            onClick={() => { return logicRule?.rule_type === LOGIC.toLocaleLowerCase() && logicRule?.id ? handleUpdateRule() : handleSaveMethod() }}
                            className={`  tw-rounded  tw-bg-blue-800 tw-text-white tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary`}
                        >
                            {logicRule?.rule_type === LOGIC.toLocaleLowerCase() && logicRule?.id ? "Update" : "Done"}
                        </button>
                    </div>
                </div>
                {logicRule?.rule_type === LOGIC.toLocaleLowerCase() && (
                    /* The § 104 revert (2026-09-03) stops here: CompatioLoader was
                       deleted repo-wide in § 112-117, so the loading state keeps
                       the DS Spinner while the rest of the editor is reverted. */
                    loading ? (
                        <div className="tw-flex tw-h-[670px] tw-items-center tw-justify-center">
                            <Spinner
                                size="lg"
                                label="Loading rule"
                                showLabel
                                data-testid="logic-rule-loading"
                            />
                        </div>
                    ) :
                    <div className="tw-flex  tw-bg-gray-100 tw-border tw-border-zinc-300">
                        {showPickPanel &&
                            <SidePanelComponent />
                        }

                        <LogicRuleComponent projectId={props?.projectId} />
                    </div>
                )}

            </div>
        </div>
    );
};

export default RulesDialog;
